import React, { Fragment, useState } from 'react';
import { Container, Collapse, Row, Col } from 'reactstrap';
import { MinusIcon, PlusIcon } from '../../common/icons';
import { Link } from 'react-router-dom';
import * as Icons from '../../common/icons/emergingTechnologiesServiceIcons';
import SkeletonTechIndustry from './SkeletonTechIndustry';
// import { HashLink as Link } from 'react-router-hash-link';
// import techImg from '../../assets/images/landingpage/smiling-executives-waiting-meeting.png'


const TechIndustryQuality = (props) => {
    const techIndustryData = props?.techIndustryQualityData;
    const [state, setState] = useState({
        articleOpen: 0,
        moreInfoOpen: true
    });

    const toggle = (index) => {
        setState({
            articleOpen: index,
            moreInfoOpen: !state.moreInfoOpen
        });
    };
    if (!techIndustryData || Object.keys(techIndustryData).length === 0) {
        return (
            <SkeletonTechIndustry />
        );
    }

    return (
        <>
            {/* <SkeletonTechIndustry /> */}
            <section className='Tech-Industry-Quality'>
                <div className='tech-content' style={{ backgroundImage: `url(${techIndustryData?.bgImg})` }}>
                    <div className='bg-color-rgba h-100'>
                        <Container className="pe-5">
                            <Row className="justify-content-start h-100">
                                <Col lg="7" md="7" className="align-self-center">
                                    <div className='page-content'>
                                        <h3>{techIndustryData?.pageHeading}</h3>
                                        {techIndustryData?.futureProof?.length > 0 && <div className='my-3'>
                                            {techIndustryData?.futureProof?.map((future, index) => {
                                                const Icon = Icons[future?.icon] || null;
                                                // const Icon = future?.icon;
                                                return (
                                                    <p key={index}>
                                                        {Icon && <Icon />} {future?.title}
                                                    </p>
                                                );
                                            })}
                                        </div>}
                                        <p>{
                                            techIndustryData?.pageParagraph?.text}
                                            {techIndustryData?.pageParagraph?.link?.trim() &&
                                                <Link className='text-decoration-none text-white' to={window?.location?.origin}>
                                                    {typeof techIndustryData?.pageParagraph?.link === 'function'
                                                        ? techIndustryData?.pageParagraph?.link()
                                                        : techIndustryData?.pageParagraph?.link}
                                                </Link>}
                                            {techIndustryData?.pageParagraph?.text1}
                                        </p>
                                        {techIndustryData?.pageParagraph1 &&
                                            <p>
                                                {techIndustryData?.pageParagraph1?.text}
                                                {techIndustryData?.pageParagraph1?.link?.trim() && (
                                                    <Link className="text-decoration-none text-white" to="/">
                                                        {techIndustryData.pageParagraph1.link}
                                                    </Link>
                                                )}
                                                {techIndustryData?.pageParagraph1?.text1}
                                            </p>}
                                    </div>
                                    {techIndustryData?.faqData?.length > 0 && <div className='tech-faq'>
                                        {techIndustryData?.faqData?.map((faq, index) => {
                                            return (
                                                <Fragment key={index}>
                                                    <div className='d-flex justify-content-start align-items-center gap-3' onClick={() => toggle(index)} style={{ marginBottom: '1rem' }}>
                                                        {state && index === state?.articleOpen ? <MinusIcon /> : <PlusIcon />}
                                                        <h4>{faq?.title}</h4>
                                                    </div>
                                                    <Collapse isOpen={index === state?.articleOpen}>
                                                        <div className='tech-faq-content'>
                                                            {faq?.paragraph?.map((faq_para, para_index) => {
                                                                return (
                                                                    <p key={para_index} className='tech-faq-content-body'>
                                                                        {faq_para?.text}
                                                                    </p>
                                                                )
                                                            })}
                                                        </div>
                                                    </Collapse>
                                                </Fragment>
                                            )
                                        })}
                                    </div>}
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </section>
        </>
    );
}

export default TechIndustryQuality;
